var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.budget)?_c('div',{staticClass:"budget_estimate shadow"},[_c('h1',[_vm._v("Budget estimate")]),_c('h2',[_vm._v("$"+_vm._s(_vm.budget)+" ≈ "+_vm._s(_vm.estimatedHours)+" hrs")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }